import { atom } from 'jotai';
import { lang } from '@dana/components';
import { getInitialLanguage } from '../lang/language';

const initialLanguage = getInitialLanguage();
const langState = atom<string>(initialLanguage);

(lang as any).lang = initialLanguage;
if (typeof window !== 'undefined') {
  (window as any).lan = initialLanguage;
}

export const langAtom = atom(
  (get) => get(langState),
  (get, set, b: string) => {
    set(langState, b);
  },
);
